import React from "react";

const Social = () => {
      const socialIcons = [
            { 
                  id: 'olmo-homes-social-media-facebook', 
                  socialMedia: 'facebook', 
                  iconName: 'fab fa-facebook-f', 
                  link: 'https://www.facebook.com/share/1Fca7akSoN/?mibextid=wwXIfr' 
            },
            { 
                  id: 'olmo-homes-social-media-instagram', 
                  socialMedia: 'instagram', 
                  iconName: 'fab fa-instagram', 
                  link: 'https://www.instagram.com/olmo.homes?igsh=MTVsbnI4cDJudW01YQ==' 
            },
            { 
                  id: 'olmo-homes-social-media-linkedin', 
                  socialMedia: 'linkedin', 
                  iconName: 'fab fa-linkedin-in', 
                  link: 'https://www.linkedin.com/company/olmohomes/' 
            },
      ];

      return (
            <div className="social-style1 light-style" style={{ display: 'flex', gap: 8, marginTop: 24 }}>
                  {socialIcons.map((social) => (
                        <a key={social.id} href={social.link} target="_blank">
                              <i className={social.iconName + " list-inline-item"}
                                    style={{
                                          color: "#222529",
                                          width: 40,
                                          height: 40,
                                          borderRadius: 40,
                                          backgroundColor: '#FAF9F7'
                                    }}
                              />
                        </a>
                  ))}
            </div>
      );
};

export default Social;
